import { defineMessages } from 'react-intl';

/** The states of the screen and of each source (design f1 to f5). */
export const streamingStateMessages = defineMessages({
  noSourceTitle: { id: 'app.sml.streaming.state.noSource.title', defaultMessage: 'No source connected yet' },
  noSourceText: {
    id: 'app.sml.streaming.state.noSource.text',
    defaultMessage:
      'Connect Spotify for Artists, Deezer for Creators, YouTube or your distributor in Catalog. MUSIC24 then reads your numbers every day and shows them here.',
  },
  noSourceButton: { id: 'app.sml.streaming.state.noSource.button', defaultMessage: 'Connect a source in Catalog' },
  whatEachGives: { id: 'app.sml.streaming.state.whatEachGives', defaultMessage: 'What each source gives' },
  kindPortal: { id: 'app.sml.streaming.state.kind.portal', defaultMessage: 'Artist portal' },
  kindDistributor: { id: 'app.sml.streaming.state.kind.distributor', defaultMessage: 'Distributor' },
  kindChannel: { id: 'app.sml.streaming.state.kind.channel', defaultMessage: 'Channel' },
  givesStores: { id: 'app.sml.streaming.gives.stores', defaultMessage: 'Stores' },
  givesCountries: { id: 'app.sml.streaming.gives.countries', defaultMessage: 'Countries' },
  givesPlaylists: { id: 'app.sml.streaming.gives.playlists', defaultMessage: 'Playlists' },
  givesEarnings: { id: 'app.sml.streaming.gives.earnings', defaultMessage: 'Earnings' },
  givesViews: { id: 'app.sml.streaming.gives.views', defaultMessage: 'Views' },
  sourcesNote: {
    id: 'app.sml.streaming.state.sourcesNote',
    defaultMessage:
      'Each section shows what your connected sources report. A direct connection, such as Spotify for Artists, gives its own store. A distributor, such as Ditto, covers many stores at once.',
  },
  connectSource: {
    id: 'app.sml.streaming.state.connectSource',
    defaultMessage: 'Connect a source in Catalog',
  },
  firstRead: {
    id: 'app.sml.streaming.state.firstRead',
    defaultMessage: 'Reading your numbers from {source}. The first read takes a few minutes.',
  },
  reconnectLine: {
    id: 'app.sml.streaming.state.reconnectLine',
    defaultMessage: '{source} is signed out. Its numbers stop at {date}.',
  },
  reconnectLink: { id: 'app.sml.streaming.state.reconnectLink', defaultMessage: 'Reconnect in Catalog' },
  disconnectedLine: {
    id: 'app.sml.streaming.state.disconnectedLine',
    defaultMessage: '{source} is disconnected. Streaming keeps its numbers up to {date}. MUSIC24 reads no new numbers.',
  },
  connectAgainLink: { id: 'app.sml.streaming.state.connectAgainLink', defaultMessage: 'Connect again in Catalog' },
  chooseArtistLink: { id: 'app.sml.streaming.state.chooseArtistLink', defaultMessage: 'Choose artist in Catalog' },
  cardReadToday: { id: 'app.sml.streaming.source.readToday', defaultMessage: 'Read today, {time}' },
  cardLastRead: { id: 'app.sml.streaming.source.lastRead', defaultMessage: 'Last read {date}' },
  cardWaiting: { id: 'app.sml.streaming.source.waiting', defaultMessage: 'Waiting for the first sync' },
  cardFirstRead: {
    id: 'app.sml.streaming.source.firstRead',
    defaultMessage: 'Reading your numbers. This takes a few minutes.',
  },
  cardSignedOut: {
    id: 'app.sml.streaming.source.signedOut',
    defaultMessage: 'Signed out. Your numbers stop at {date}.',
  },
  cardSignedOutNoDate: { id: 'app.sml.streaming.source.signedOutNoDate', defaultMessage: 'Signed out.' },
  cardDisconnected: {
    id: 'app.sml.streaming.source.disconnected',
    defaultMessage: 'Disconnected. Your numbers up to {date} stay here. No new read.',
  },
  cardDisconnectedNoDate: {
    id: 'app.sml.streaming.source.disconnectedNoDate',
    defaultMessage: 'Disconnected. Your numbers stay here. No new read.',
  },
  cardFailed: {
    id: 'app.sml.streaming.source.failed',
    defaultMessage: 'The last read failed. MUSIC24 tries again tonight.',
  },
  cardNoArtist: {
    id: 'app.sml.streaming.source.noArtist',
    defaultMessage: 'No artist chosen yet, so there are no numbers.',
  },
  sourcesTitle: { id: 'app.sml.streaming.sources.title', defaultMessage: 'Where these numbers come from' },
  sourcesCount: {
    id: 'app.sml.streaming.sources.count',
    defaultMessage: '{count, plural, one {# source} other {# sources}}',
  },
  manageSources: { id: 'app.sml.streaming.sources.manage', defaultMessage: 'Manage sources in Catalog' },
  sourcesFooter: {
    id: 'app.sml.streaming.sources.footer',
    defaultMessage: 'MUSIC24 reads every source once a day. Portal numbers are about two days behind.',
  },
});
